// extracted by mini-css-extract-plugin
module.exports = {"numberOfTicketsRow":"styles_numberOfTicketsRow__1Cn-7","buttonRow":"styles_buttonRow__3MxDA"};